"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "4.0.28";



//////////////////
// WEBPACK FOOTER
// ./~/ethers/_version.js
// module id = 2247
// module chunks = 0 1